"use client";
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import "../DatosOfertaForm.css";
import {
  Calendar,
  Calendar1,
  CalendarDays,
  Check,
  ChevronRight,
  CircleDollarSign,
  Coins,
  CreditCard,
  CreditCardCheck,
  Edit3,
  FileText,
  HandCoins,
  Pencil,
  Percent,
  ShieldCheck,
  ShieldLock,
  Signature,
  Zap,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Numeral } from "../../../../components/numeral/Numeral";
import { EmailOutlined, Money } from "@mui/icons-material";

import { ReactComponent as GalileIcon } from "../../../../public/logos/galilea-icono.svg";
import { BottomSheet } from "../../../../components/new_components/BottomSheet";
import { FechasRadioGroup } from "../../../../components/new_components/fechasRadioGroup";
import { ReactComponent as ArrowRight } from "../../../../public/svg/ArrowRight2.svg";
import { ContractV3 } from "../../../../components/new_components/Agreements/ContractV3";
import { PromissoryV2 } from "../../../../components/new_components/Agreements/PromissoryV2";
import AnimationComponent from "../../../../components/new_components/animation";
import { ManualSignV3 } from "../../../../components/new_components/Agreements/ManualSignV3";
import { creditOfferStore } from "../../../../store/creditStore/offerCreditStore";
import { APIClient } from "../../../../helpers/api_helper";
import { REQUEST_PROCESS_PHYSICAL_SIGNATURE } from "../../../../helpers/url_helper";
import { calcDescuentoFirmaElectronicaV1 } from "../../../../utils/creditUser/calcDctoFirmaElectronica";
import { convertToNumber, isValidNumber } from "../../../../utils/isValidNumber";
import {
  calcInteresCorrienteV2,
  calcularInteresCorrienteTed,
  calcularInteresCorrienteTem,
} from "../../../../utils/creditUser/calcInteresCorriente";
import { variablesGlobales } from "../../../../configs/variables";
import {
  getAndSetInterestTea,
  getInterest,
} from "../../../../utils/creditUser/getInterest";
import { CreditsService } from "../../../../services/credits/credits.service";
import moment from "moment/moment";
import { useCreditStore } from "../../../../store/creditStore/creditUserStore";

import { InfoAlert } from "../../../../components/alerts/infoAlert";
import { ErrorAlert } from "../../../../components/alerts/errorAlert";
import { GET_SETTING_BY_NAME } from "../../../../helpers/url_helper";
import { validateCreditDatesFromViewOffer } from "../../helpers/helper";
import axios from "axios";
import { useAlert } from "../bankFlowSelector/provider/alertProvider";
import {
  NextButton,
  PrevButton,
} from "../../../../components/new_components/buttonsFlow";
import { userBankStore } from "../../../../store/creditStore/userBankStore";
import { stepsCreditStore } from "../../../../store/creditStore/stepsCreditStore";
import { VeriffService } from "../../../../services/veriff/veriff.service";
import {
  loadInfoUser,
  loadInfoUserAuth,
} from "../../../../utils/creditUser/helpers";
import { homologateBankNameAccount } from "../../../../utils/options_selects";
import StepContainer from "../../../../components/new_components/StepContainer";
import { useMobileDetection } from "../../../../hooks/use-mobile-detection";
import { HttpRequest } from "../../../../services/httpRequest";
import AmountSlider from "../../../../components/new_components/AmountSlider";
import { montoElegido, rangoMonto, trackEvent, trackEventOnce } from "../../../../services/analytics/track";

const apiClient = new APIClient();
const settingName = "redirect-denied";
const urlCrezu = "https://track.leadbazaar.co/click?pid=6180&offer_id=389";

const RenovarDatosOfertaForm = ({
  onStepChange,
  stepTitlesGeneral,
  currentStepGeneral,
  isDesktop,
  currentStep: parentStep,
  onInternalStepChange,
  backRef
}) => {
  const navigate = useNavigate();

  const { showAlert } = useAlert();

  const {
    offerCreditStore,
    saveOfertCredit,
    loadOfertCredit,
    clearOfertCredit,
  } = creditOfferStore();
  const { creditUserStore, saveUser, loadUser, clearUser } = useCreditStore();
  const { clearUserBank } = userBankStore();
  const { clearSteps } = stepsCreditStore();

  const [url, setUrl] = useState(urlCrezu);
  const { screenHeight } = useMobileDetection();

  const [vencimientoEnDias, setVencimientoEnDias] = useState(0);
  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenError, setIsOpenError] = useState(false);
  const [alertSession, setAlertSession] = useState(false);
  const [isOpenInfo, setIsOpenInfo] = useState(false);

  const [totalSteps, setTotalSteps] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isNotApprovedCridit, setIsNotApprovedCridit] = useState(false);
  const [isApprovedCridit, setIsApprovedCridit] = useState(false);
  const [viewAprobate, setViewAprobate] = useState(0);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [openSheetFechas, setOpenSheetFechas] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [titleDialog, setTitleDialog] = useState(false);
  const [descriptionDialog, setDescriptionDialog] = useState(false);
  const [isSelectedTipoFirma, setIsSelectedTipoFirma] = useState("electronica");
  const [openSheetFirma, setOpenSheetFirma] = useState(false);
  const [openSheetRangoQupo, setOpenSheetRangoQupo] = useState(false);
  const [dialogOpenContrato, setDialogOpenContrato] = useState(false);
  const [fechaSelected, setFechaSelected] = useState();
  const [activeTab, setActiveTab] = useState("contrato");

  const [dialogOpenContratoFirma, setDialogOpenContratoFirma] = useState(false);
  const [rewardHistoryAvailable] = useState();
  const [, setDiscountForReward] = useState(null);
  const [checkFirmaElectronica, setCheckFirmaElectronica] = useState(true);
  const [interest, setInterest] = useState(0);

  const [total, setTotal] = useState(0);
  const [firmaElectronicaValue, setFirmaElectronicaValue] = useState(0);
  const [dctoFirmaElectronica, setDctoFirmaElectronica] = useState(0);
  const [isDesktopReize] = useState(false);
  const [tasaUsuraTmlvRate, setTasaUsuraTmlvRate] = useState("");
  const [limitFirmaFisica, setLimitFirmaFisica] = useState(0);

  // Snapshots sin volverlos dependencia reactiva de calculateInterest/calcFirmaElectronica/
  // calcDiscountForReward: esos estados los escribe el MISMO efecto que los calcula, así
  // que depender de ellos reactivamente reintroduciría el ciclo documentado más abajo.
  const tasaUsuraTmlvRateRef = useRef(tasaUsuraTmlvRate);
  useEffect(() => {
    tasaUsuraTmlvRateRef.current = tasaUsuraTmlvRate;
  });
  const firmaElectronicaValueRef = useRef(firmaElectronicaValue);
  useEffect(() => {
    firmaElectronicaValueRef.current = firmaElectronicaValue;
  });
  const offerCreditStoreRef = useRef(offerCreditStore);
  useEffect(() => {
    offerCreditStoreRef.current = offerCreditStore;
  });

  const [isTransitioning, setIsTransitioning] = useState(false);

  const [selectedQuota, setSelectedQuota] = useState(0);
  const [cupoDisponible, setCupoDisponible] = useState(0);
  const [formDataOferta, setFormDataOferta] = useState({
    approvedQuota: 200000,
    selectedQuota: 0,
    paydayLimit: "",
    aceptaTerminos: false,
    termInDays: 0,
    tipoFirma: "",
    total: "",
    numeroBanco: 0,
    tipoCuenta: "",
  });

  const [errors, setErrors] = useState({});
  const starsRef = useRef(null);

  const hasValidatedRef = useRef(false);

  // 1: Aprobación, 2: Firma, 3: Revisa tu oferta, 4: Condiciones, 5: Oferta de crédito

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };


  const changeTipoFirma = (value) => {
    setIsSelectedTipoFirma(value);
  };

  const getFormHeightMovil = () => {
    if (screenHeight <= 490) return "200px";
    if (screenHeight <= 500) return "210px";
    if (screenHeight <= 575) return "230px";
    if (screenHeight <= 599) return "240px";
    if (screenHeight <= 610) return "260px";
    if (screenHeight <= 650) return "300px";
    if (screenHeight <= 699) return "320px";
    if (screenHeight <= 710) return "340px";
    if (screenHeight <= 750) return "360px";
    if (screenHeight <= 799) return "440px";
    if (screenHeight <= 810) return "430px";
    if (screenHeight <= 850) return "490px";
    if (screenHeight <= 899) return "500px";
    if (screenHeight <= 910) return "460px";
    if (screenHeight <= 950) return "540px";
    if (screenHeight <= 999) return "580px";
    if (screenHeight <= 1000) return "520px";
    if (screenHeight > 1001) return "830px";
    return "820px";
  };

  const handleToggleDialog = () => {
    if (openSheetFechas) {
      setOpenSheetFechas(false);
    } else {
      setOpenSheetFechas(true);
    }
  };

  const handleOpenAlertInfo = (type, message, isOpen) => {
    /* if (type === "success") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenSuccess(isOpen);
    } */

    if (type === "info") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenInfo(isOpen);
    }

    if (type === "error") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenError(isOpen);
    }

    setTimeout(() => {
      setMessageAlert("");
      setAlertSession(!isOpen);
      setIsOpenInfo(!isOpen);
    }, 6000);
  };

  const handleToggleDialogFirma = () => {
    if (openSheetFirma) {
      setOpenSheetFirma(false);
    } else {
      setOpenSheetFirma(true);
    }
  };

  const handleToggleDialogCupo = () => {
    if (openSheetRangoQupo) {
      setOpenSheetRangoQupo(false);
    } else {
      setOpenSheetRangoQupo(true);
    }
  };

  const handleToggleDialogContratos = () => {
    if (dialogOpenContrato) {
      setDialogOpenContrato(false);
    } else {
      setDialogOpenContrato(true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormDataOferta((prev) => ({ ...prev, [name]: value }));

    if (offerCreditStore) {
      saveOfertCredit({ ...offerCreditStore, [name]: value });
    }

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    if (value === "fisica") {
      setDialogOpenContratoFirma(true);
      setCheckFirmaElectronica(false);
    } else {
      setCheckFirmaElectronica(true);
      setDialogOpenContratoFirma(false);
    }
  };

  const handleAccept = () => {
    setOpenDialog(!openDialog);
  };

  const validateTokenization = useCallback(async () => {
    const documento = localStorage.getItem("doc");
    try {
      const tokenSession = localStorage.getItem("token_jwt");
      const res = await axios.post(
        `${variablesGlobales.urlServiceBackend}/api/v1/tokenization/validate-tokenization`,
        {
          doc: documento,
        },
        {
          headers: {
            authorization: `Bearer ${tokenSession}`,
          },
        },
      );

      const data = res.data;

      if (data?.status === "AVAILABLE") {
        localStorage.setItem("tokenIdWompi", data?.payment_source_id);
      }
    } catch (err) {
      const errorMsg =
        err?.response?.data?.message ||
        "Error de conexión. Intenta nuevamente.";
      console.error("Wompi error:", err?.response?.data);
      showAlert("info", errorMsg, 8000);
    }
  }, [showAlert]);

  const handleNext = () => {
    const maxStepsMobile = 2; // Móvil: step 1 y 2
    const maxStepsWeb = 4; // Web: step 3 solamente
    setTotalSteps(true);
    if (currentStep === 2 || currentStep === 4) {
      if (formDataOferta.tipoFirma === "fisica") {
        setDialogOpenContratoFirma(true);
      } else {
        handleSubmit();
        if (onStepChange) {
          onStepChange(parentStep + 1);
        }
      }
      // Cuando alcanza el último paso permitido, avanza al siguiente paso general
    } else {
      // Navega internamente dentro de los pasos permitidos
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentStep((prev) => prev + 1);
        setIsTransitioning(false);
      }, 150);
    }

    saveOfertCredit({
      ...offerCreditStore,
      paydayLimit: formDataOferta.paydayLimit,
      tipoFirma: formDataOferta.tipoFirma,
      email: localStorage.getItem("email"),
      phone: localStorage.getItem("phone"),
    });
  };


  const handlePrev = () => {
    setTotalSteps(false);
    if (currentStep > 1) {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentStep((prev) => prev - 1);
        setIsTransitioning(false);
      }, 150);
    } else if (currentStep === 1 && backRef?.current) {
      // Si estamos en el paso 1, usar el back del padre
      backRef.current();
    }
  };

  const handleSubmit = async () => {
    try {
      setIsLoadingButton(true);
      localStorage.setItem("type_user", variablesGlobales.typeUSerClient);
      if (vencimientoEnDias <= 0) {
        setIsLoadingButton(false);
        handleOpenAlertInfo(
          "info",
          "Debes modificar la fecha de pago ya que debe ser mayor a la fecha actual",
          true,
        );
        setTimeout(() => {
          handleToggleDialog();
        }, 3000);
        return;
      }
      trackEvent("oferta_aceptada", {
        monto: montoElegido(offerCreditStore),
        plazo_dias: vencimientoEnDias,
        tipo_cliente: "renovacion",
      });

      setTimeout(() => {
        let nextStet = 1;
        /* if (
          creditUserStore.renovar === true ||
          creditUserStore.renovar === "true" ||
          creditUserStore.statusCredit === creditStatus.PF ||
          creditUserStore.statusCredit === creditStatus.S
        ) {
          nextStet = 2;
        } */
        if (onStepChange) {
          onStepChange(parentStep + nextStet); // o el número de paso que desees
        }
        updateCredit(false);
        setIsLoadingButton(false);
      }, 3000);
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
    }
  };

  const calcDiscountForReward = useCallback((availableReward) => {
    if (availableReward && availableReward?.rewardHistoryAvailable) {
      let shortCode = availableReward?.shortCodeReward;
      let typeReward = String(shortCode).substring(1, 3);
      if (typeReward === "10") {
        let percentage =
          availableReward?.rewardHistoryAvailable?.percentDiscount;
        let discountReward =
          (firmaElectronicaValueRef.current * percentage) / 100;
        return discountReward;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }, []);

  const calcFirmaElectronica = useCallback((amount, vencimientoEnDias) => {
    let _firmaElectronica = firmaElectronicaValueRef.current;
    let dctoFirmaElectronica = calcDescuentoFirmaElectronicaV1(
      amount,
      vencimientoEnDias,
    );
    let _firmaElectronicaTotal;
    if (dctoFirmaElectronica === _firmaElectronica) {
      setDctoFirmaElectronica(0);
      _firmaElectronicaTotal = _firmaElectronica;
    } else {
      setDctoFirmaElectronica(dctoFirmaElectronica);
      _firmaElectronicaTotal = _firmaElectronica - dctoFirmaElectronica;
    }
    return _firmaElectronicaTotal;
  }, []);

  const calculateInterest = useCallback((amount, vencimientoEnDias, rate) => {
    let tasa = localStorage.getItem("currentInterestRate");
    let tea = localStorage.getItem("currentInterestTea");
    tea = convertToNumber(tea);
    let tasaUsuraTmlv = tasaUsuraTmlvRateRef.current;
    if (tasaUsuraTmlv === undefined && rate !== undefined) {
      tasaUsuraTmlv = rate;
    }
    tasaUsuraTmlv = parseFloat(tasaUsuraTmlv.replace(",", "."));
    if (!isValidNumber(tea)) tea = 0;

    //si la tasa efectiva anual de interes corriente es mayor a la tasa de usura de la tasa máxima legal permitida se aplica la tasa de usura de la tasa máxima legal permitida
    if (tea > tasaUsuraTmlv) {
      tea = tasaUsuraTmlv;
      localStorage.setItem("currentInterestTea", tea);
      let tasaNueva = calcCurrentInterestTed(tea);
      localStorage.setItem("currentInterestRate", tasaNueva);
      tasa = tasaNueva;
    }
    const interest2 = calcInteresCorrienteV2(amount, vencimientoEnDias, tasa);
    return interest2;
  }, []);

  const calculateTotal = useCallback((amount, vencimientoEnDias) => {
    if (formDataOferta.tipoFirma === "electronica") {
      let total =
        amount +
        calculateInterest(amount, vencimientoEnDias) +
        calcFirmaElectronica(amount, vencimientoEnDias);
      return total;
    } else {
      let total = amount + calculateInterest(amount, vencimientoEnDias);
      setDctoFirmaElectronica(firmaElectronicaValueRef.current);
      return total;
    }
  }, [formDataOferta.tipoFirma, calculateInterest, calcFirmaElectronica]);

  const calcCurrentInterestTed = (tea) => {
    let interesCorrienteTea = parseFloat(tea);
    let interesCorrienteTem = calcularInteresCorrienteTem(interesCorrienteTea);
    let interesCorrienteTed = calcularInteresCorrienteTed(interesCorrienteTem);
    return interesCorrienteTed;
  };

  const updateCredit = async (isPhysical) => {
    let creditPayload = preparePayload(isPhysical);
    try {
      await CreditsService.updateCreditFromOfferPage({
        credit: creditPayload,
        creditId: localStorage.getItem("credit_id"),
        documento: localStorage.getItem("doc"),
      });
    } catch (error) {
      console.log("Error al actualizar el credito");
      console.log(error);
    }
  };

  const handleRequestPhysicalSignature = async () => {
    try {
      setIsLoading(true);
      setTitleDialog("Firma fisica");
      setDescriptionDialog(
        "Hemos enviado a tu correo electrónico un email con los documentos que debes firmar.",
      );
      updateCredit(true);

      const response = await apiClient.create(
        REQUEST_PROCESS_PHYSICAL_SIGNATURE,
        {
          documento: localStorage.getItem("doc"),
          creditId: localStorage.getItem("credit_id"),
        },
      );

      if (response.status === 200) {
        const newLimit = limitFirmaFisica + 1;
        setTimeout(() => {
          setDialogOpenContratoFirma(false);
          setIsLoading(false);
          setOpenDialog(true);
          setLimitFirmaFisica(newLimit);
          localStorage.setItem("limitFirmaFisica", String(newLimit));
        }, 5000);
        return;
      }
      setTimeout(() => {
        setDialogOpenContratoFirma(false);
        setIsLoading(false);
      }, 3000);
    } catch (error) {
      setDialogOpenContratoFirma(false);
      setIsLoading(false);
      console.log(error);
      return;
    }
  };

  const preparePayload = (isPhysical = false) => {
    let newCreditData = { ...offerCreditStore };
    newCreditData.totalToPay = total;
    newCreditData.firmaElectronica = !isPhysical ? firmaElectronicaValue : 0;
    newCreditData.dctoFirmaElectronica = !isPhysical ? dctoFirmaElectronica : 0;
    newCreditData.interestRate = !isPhysical ? newCreditData.interestRate : 0;
    newCreditData.tipoFirma = !isPhysical ? "electronica" : "fisica";
    newCreditData.status = "Pendiente de firmar";
    newCreditData.tasaInteresCorriente = localStorage.getItem(
      "currentInterestRate",
    );
    let acceptanceDate = moment().format("DD/MM/YYYY");

    let creditPayload = {
      approvedQuota: newCreditData.selectedQuota,
      requestedAmount: newCreditData.selectedQuota,
      termInDays: newCreditData.termInDays,
      totalToPay: total,
      paydayLimit: newCreditData.paydayLimit,
      interestRate: newCreditData.interestRate,
      dctoFirmaElectronica: newCreditData.dctoFirmaElectronica,
      acceptanceDate: formDataOferta.tipoFirma === "electronica" ? acceptanceDate : "",
      tipoFirma: newCreditData.tipoFirma,
      firmaElectronica: newCreditData.firmaElectronica,
      tasaInteresCorriente: newCreditData.tasaInteresCorriente,
    };
    return creditPayload;
  };

  const loadSetting = async () => {
    try {
      let { data } = await apiClient.get(GET_SETTING_BY_NAME, {
        name: settingName,
      });
      let value = data?.data?.value;
      return value;
    } catch (error) {
      throw error;
    }
  };

  const cleanIndexDB = () => {
    clearUser();
    clearUserBank();
    clearOfertCredit();
    clearSteps();
    localStorage.clear();
  };

  const fetchVerificationStatus = async () => {
    try {
      const response = await VeriffService.getStatus();
      const backendStatus = response?.status; // PENDING, APPROVED, DECLINED

      switch (backendStatus) {
        case "APPROVED":
        case "DECLINED":
        case "PENDING":
          localStorage.setItem("veriffStatus", backendStatus);
          break;

        default:
          break;
      }
    } catch (error) {
      console.error("Error fetching Veriff status:", error);
      // In case of API failure (network issue, etc.), we don't break immediately, just let polling retry
    }
  };

  const loadInfoQuota = useCallback(async () => {
    try {
      const data = await HttpRequest.getQuotaStatus(
        localStorage.getItem("doc"),
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  }, []);

  // Inicializar currentStep según el dispositivo
  useEffect(() => {
    const initializeQuota = async () => {
      try {
        const quotaStatus = await loadInfoQuota();
        const cupoDisponible =
          quotaStatus?.cupoUtilizado && Number(quotaStatus.cupoUtilizado) !== 0
            ? quotaStatus.cupoDisponible
            : quotaStatus?.cupoDisponible || quotaStatus?.cupoAprobado;

        setCupoDisponible(cupoDisponible);
        setFormDataOferta((prev) => ({
          ...prev,
          selectedQuota: cupoDisponible,
          approvedQuota: cupoDisponible,
        }));
      } catch (error) {
        console.error("Error initializing quota:", error);
      } finally {
        setIsLoading(false);
      }
    };

    initializeQuota();
  }, [loadInfoQuota]);

  useEffect(() => {
    setCurrentStep(isDesktop ? 3 : 1);
  }, [isDesktop]);

  useEffect(() => {
    const getUserData = async () => {
      try {
        const doc = localStorage.getItem("doc");

        if (!doc) {
          console.error("No existe doc en localStorage");
          return;
        }

        const infoUser = await loadInfoUser(doc);
        const infoUserAuth = await loadInfoUserAuth(doc);

        localStorage.setItem("phone", infoUserAuth.phone);
        localStorage.setItem("email", infoUserAuth.email);

        saveUser({
          ...infoUser,
          bankAccount: homologateBankNameAccount(infoUser.bankAccount, "value"),
        });

        saveOfertCredit({
          ...offerCreditStoreRef.current,
          infoUserAuth,
        });
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    getUserData();
  }, [saveOfertCredit, saveUser]);

  useEffect(() => {
    fetchVerificationStatus();
  }, []);

  useEffect(() => {
    loadOfertCredit();
    loadUser();
  }, [loadOfertCredit, loadUser]);

  useEffect(() => {
    const creditAprobate = localStorage.getItem("credit_aprobate");
    const approvedViewed = localStorage.getItem("approved_viewed");

    if (creditAprobate === "false" || !creditAprobate) {
      setIsApprovedCridit(false);
      setIsNotApprovedCridit(true);
      return;
    }

    if (offerCreditStore) {
      trackEventOnce("oferta-vista-renovacion", "oferta_vista", {
        rango_monto: rangoMonto(offerCreditStore.approvedQuota),
        tipo_cliente: "renovacion",
      });
      setFormDataOferta({
        ...offerCreditStore,
        approvedQuota: offerCreditStore.approvedQuota,
        requestedAmount: offerCreditStore.selectedQuota,
        selectedQuota: offerCreditStore.selectedQuota
          ? offerCreditStore.selectedQuota
          : offerCreditStore.approvedQuota,
        paydayLimit: offerCreditStore.paydayLimit,
        termInDays: offerCreditStore.termInDays,
        tipoFirma: offerCreditStore.tipoFirma,
      });
      setSelectedQuota(
        offerCreditStore.selectedQuota
          ? offerCreditStore.selectedQuota
          : offerCreditStore.approvedQuota,
      );
    }

    if (approvedViewed === "true") {
      setIsApprovedCridit(false);
      return;
    }

    if (creditAprobate === "true" && viewAprobate === 0) {
      setIsNotApprovedCridit(false);
      setIsApprovedCridit(true);
      setTimeout(() => {
        setIsApprovedCridit(false);
        setViewAprobate(1);
        localStorage.setItem("approved_viewed", "true");
      }, 4000);
    }

    const limitFirma = localStorage.getItem("limitFirmaFisica");
    setLimitFirmaFisica(limitFirma ? parseInt(limitFirma) : 0);
  }, [offerCreditStore, viewAprobate]);

  useEffect(() => {
    if (!formDataOferta.paydayLimit) return;

    const d = moment(formDataOferta.paydayLimit, "DD/MM/YYYY");
    const diff = d.diff(moment(), "days") + 1;

    setVencimientoEnDias(diff);
  }, [formDataOferta.paydayLimit]);

  useEffect(() => {
    if (!offerCreditStore || vencimientoEnDias <= 0) return;

    (async () => {
      let _tmlvData = localStorage.getItem("tmlv");
      let rate = "25,00";

      if (_tmlvData) {
        const Tmlv = JSON.parse(_tmlvData);
        rate = Tmlv?.[0]?.rate ?? "25,00";
        setTasaUsuraTmlvRate(rate);
      }

      await getInterest();

      const _interest = calculateInterest(
        convertToNumber(formDataOferta.selectedQuota),
        vencimientoEnDias,
        rate,
      );

      setInterest(_interest);
      await getAndSetInterestTea();
    })();
  }, [vencimientoEnDias, formDataOferta, calculateInterest]);

  useEffect(() => {
    if (!offerCreditStore || vencimientoEnDias <= 0) return;

    setFirmaElectronicaValue(variablesGlobales.firmaElectronica);

    let discount = calcDiscountForReward(rewardHistoryAvailable);
    setDiscountForReward(discount);

    const _total = calculateTotal(
      convertToNumber(formDataOferta.selectedQuota),
      vencimientoEnDias,
    );

    setTotal(formDataOferta.tipoFirma === "electronica" ? _total - discount : _total);
  }, [
    rewardHistoryAvailable,
    formDataOferta.tipoFirma,
    interest,
    vencimientoEnDias,
    offerCreditStore,
    calcDiscountForReward,
    calculateTotal,
  ]);

  useEffect(() => {
    setFormDataOferta((prev) => ({
      ...prev,
      total,
    }));
  }, [total]);
  useEffect(() => {
    validateTokenization();
  }, [validateTokenization]);

  useEffect(() => {
    if (isNotApprovedCridit) {
      setIsLoading(true);
      loadSetting()
        .then((value) => {
          if (Array.isArray(value) && value.length > 0) {
            let redirectDenied = value.find((item) => item.active === true);
            if (redirectDenied) {
              console.log(
                `La url de redireccion es: ${redirectDenied?.url} del parter: ${redirectDenied?.name}`,
              );
              setUrl(redirectDenied.url);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [isNotApprovedCridit]);

  useEffect(() => {
    const initializeData = async () => {
      if (!offerCreditStore || hasValidatedRef.current) return;

      hasValidatedRef.current = true;

      let initialData = { ...offerCreditStore };

      const { isChanges, creditChanges } =
        await validateCreditDatesFromViewOffer(offerCreditStore);

      if (isChanges && creditChanges) {
        initialData = {
          ...initialData,
          approvedDate: creditChanges.approvedDate,
          paydayLimit: creditChanges.paydayLimit,
          termInDays: creditChanges.termInDays,
          totalToPay: creditChanges.totalToPay,
          versionTarifas: creditChanges.versionTarifas,
          versionContrato: creditChanges.versionContrato,
        };

        saveOfertCredit({
          ...offerCreditStore,
          approvedDate: creditChanges.approvedDate,
          paydayLimit: creditChanges.paydayLimit,
          termInDays: creditChanges.termInDays,
          totalToPay: creditChanges.totalToPay,
          versionTarifas: creditChanges.versionTarifas,
          versionContrato: creditChanges.versionContrato,
        });
      }

      // Setear los valores en el estado del formulario
      setFormDataOferta({
        ...initialData,
        approvedDate: initialData.approvedDate,
        paydayLimit: initialData.paydayLimit,
        termInDays: initialData.termInDays,
        totalToPay: initialData.totalToPay,
        versionTarifas: initialData.versionTarifas,
        versionContrato: initialData.versionContrato,
      });
    };

    initializeData();
  }, [offerCreditStore, saveOfertCredit]);

  useEffect(() => {
    const canvas = starsRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let W = 0;
    let H = 0;
    let stars = [];
    let animationId;

    const resize = () => {
      W = canvas.width = window.innerWidth;
      H = canvas.height = window.innerHeight;
    };

    const createStar = () => ({
      x: Math.random() * W,
      y: Math.random() * H,
      r: Math.random() * 1 + 0.2,
      a: Math.random(),
      da: (Math.random() * 0.005 + 0.001) * (Math.random() < 0.5 ? 1 : -1),
    });

    const init = () => {
      resize();
      stars = Array.from({ length: 160 }, createStar);
    };

    const draw = () => {
      ctx.clearRect(0, 0, W, H);

      for (const star of stars) {
        star.a += star.da;

        if (star.a <= 0.04 || star.a >= 1) {
          star.da *= -1;
        }

        ctx.beginPath();
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${star.a.toFixed(2)})`;
        ctx.fill();
      }

      animationId = requestAnimationFrame(draw);
    };

    window.addEventListener("resize", resize);

    init();
    draw();

    return () => {
      window.removeEventListener("resize", resize);
      cancelAnimationFrame(animationId);
    };
  }, []);

  const goToStep = (step) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentStep(step);
      setIsTransitioning(false);
    }, 150);
  };

  // Pantallas bajas: se oculta información secundaria para evitar scroll
  const [isShortScreen, setIsShortScreen] = useState(
    typeof window !== "undefined" && window.innerHeight < 720,
  );
  useEffect(() => {
    const onResize = () => setIsShortScreen(window.innerHeight < 720);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Expone al header del padre el paso interno actual y la acción de volver
  useEffect(() => {
    onInternalStepChange?.(currentStep);
    if (backRef) {
      backRef.current = () => {
        if (currentStep > 1) {
          setTotalSteps(false);
          goToStep(currentStep - 1);
        }
      };
    }
  });

  const handleConfirmTipoFirma = () => {
    const tipo = isSelectedTipoFirma;
    setFormDataOferta((prev) => ({ ...prev, tipoFirma: tipo }));
    setCheckFirmaElectronica(tipo === "electronica");
    saveOfertCredit({ ...offerCreditStore, tipoFirma: tipo });
    goToStep(3);
  };

  const formatFechaLarga = (fecha) => {
    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];
    const m = moment(fecha, "DD/MM/YYYY");
    if (!fecha || !m.isValid()) return fecha || "-";
    return `${m.date()} de ${meses[m.month()]} de ${m.year()}`;
  };

  // Estilos compartidos de los pasos previos (1 al 4)
  const stepWrapStyle = {
    width: "100%",
    maxWidth: isDesktop ? "900px" : "100%",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: isDesktop ? "16px" : "clamp(8px, 1.6vh, 16px)",
  };
  const stepCardStyle = {
    background: "linear-gradient(145deg, rgba(28, 18, 43, 0.95) 0%, rgba(13, 9, 20, 0.98) 100%)",
    border: "1px solid rgba(201, 184, 255, 0.25)",
    borderRadius: "1.25rem",
    padding: isDesktop ? "16px 20px" : "clamp(10px, 1.8vh, 16px) 16px",
  };
  const stepTitleStyle = {
    textAlign: "center",
    color: "#FAFAFA",
    fontSize: isDesktop ? "clamp(24px, 2.2vw, 36px)" : "clamp(22px, 4vh, 30px)",
    lineHeight: 1.2,
  };
  const stepSubtitleStyle = {
    textAlign: "center",
    color: "#BEBCC2",
    fontSize: isDesktop ? "15px" : "clamp(14px, 2.2vh, 16px)",
  };
  const iconCircleStyle = {
    width: "clamp(34px, 5vh, 44px)",
    height: "clamp(34px, 5vh, 44px)",
    minWidth: "clamp(34px, 5vh, 44px)",
    borderRadius: "9999px",
    backgroundColor: "#2C2447",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#C9B8FF",
  };


  const renderStepTitle = (first, highlighted) => (
    <h1 className="font-bold2" style={stepTitleStyle}>
      {first}
      <br />
      <span style={{ color: "#C9B8FF" }}>{highlighted}</span>
    </h1>
  );

  const renderDetailRow = (icon, label, value, options = {}) => (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-3" style={{ color: "#FAFAFA" }}>
        <span style={{ color: "#C9B8FF", display: "flex" }}>{icon}</span>
        <span
          className={options.bold ? "font-bold2" : ""}
          style={{ fontSize: isDesktop ? "clamp(14px, 1vw, 16px)" : "clamp(13px, 2vh, 15px)" }}
        >
          {label}
        </span>
      </div>
      <span
        className="font-bold2"
        style={{
          fontSize: isDesktop ? "clamp(15px, 1.2vw, 18px)" : "clamp(14px, 2.1vh, 16px)",
          color: options.highlight ? "#C9B8FF" : "#FAFAFA",
          textAlign: "right",
        }}
      >
        {value}
      </span>
    </div>
  );

  const renderSectionHeader = (title, onEdit, textButton = "Editar") => (
    <div
      className="flex items-center justify-between"
      style={{ marginBottom: "clamp(5px, 1vw, 10px)" }}
    >
      <span
        className="font-bold2"
        style={{ color: "#FAFAFA", fontSize: isDesktop ? "clamp(16px, 1.4vw, 18px)" : "clamp(15px, 2.2vh, 17px)" }}
      >
        {title}
      </span>
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          className="flex items-center gap-1"
          style={{ color: "#C9B8FF", fontSize: "clamp(12px, 0.9vw, 13px)", cursor: "pointer" }}
        >
          <Pencil className="w-3 h-3" />
          {textButton}
        </button>
      )}
    </div>
  );

  const renderContractLink = (label) => (
    <button
      type="button"
      onClick={handleToggleDialogContratos}
      className="flex items-center justify-between w-full"
      style={{ ...stepCardStyle, cursor: "pointer", color: "#FAFAFA", padding: isDesktop ? "10px 12px" : stepCardStyle.padding }}
    >
      <div className="flex items-center gap-3">
        <FileText className="w-5 h-5" style={{ color: "#C9B8FF" }} />
        <span className="font-semibold2" style={{ fontSize: isDesktop ? "clamp(14px, 1vw, 16px)" : "16px" }}>
          {label}
        </span>
      </div>
      <ChevronRight className="w-4 h-4" />
    </button>
  );

  const renderContractSheet = () => (
    <BottomSheet
      open={dialogOpenContrato}
      onOpenChange={setDialogOpenContrato}
      isDesktop={isDesktop}
      headerContent={
        <div
          className="flex rounded-2xl mx-auto"
          style={{
            backgroundColor: "#2C2447",
            padding: "8px",
            width: "200px",
            margin: "0px",
          }}
        >
          <button
            onClick={() => handleTabClick("contrato")}
            className={`flex-1 py-2 text-sm rounded-xl transition-all ${activeTab === "contrato" ? "bg-purpleM text-white" : "text-tgray"}`}
            style={{ cursor: "pointer" }}
          >
            Contrato
          </button>
          <button
            onClick={() => handleTabClick("pagare")}
            className={`flex-1 py-2 text-sm rounded-xl transition-all ${activeTab === "pagare" ? "bg-purpleM text-white" : "text-tgray"}`}
            style={{ cursor: "pointer" }}
          >
            Pagaré
          </button>
        </div>
      }
    >
      <div className="space-y-3 w-full">
        <div
          className="h-full rounded-t-3xl overflow-auto"
          style={{ backgroundColor: "#2C2447", color: "#FAFAFA" }}
        >
          {activeTab === "contrato" ? (
            <ContractV3
              basicInfo={creditUserStore}
              userinfo={offerCreditStore}
              creditUser={offerCreditStore}
              firmaElectronica={
                formDataOferta.tipoFirma === "electronica"
                  ? firmaElectronicaValue
                  : 0
              }
              dctoFirmaElectronica={
                formDataOferta.tipoFirma === "electronica"
                  ? dctoFirmaElectronica
                  : 0
              }
              total={total}
            />
          ) : (
            <PromissoryV2
              basicInfo={creditUserStore}
              userinfo={offerCreditStore}
            />
          )}
        </div>
      </div>
    </BottomSheet>
  );

  const renderStep = () => {
    const cupo = Number(convertToNumber(formDataOferta.selectedQuota)) || 0;
    // Descuento por desembolso inmediato (solo se muestra si la oferta lo trae)
    const montoRecibido = cupo;
    const esElectronica = formDataOferta.tipoFirma === "electronica";
    const costoFirma = esElectronica
      ? Math.max(
        (Number(firmaElectronicaValue) || 0) -
        (Number(dctoFirmaElectronica) || 0),
        0,
      )
      : 0;
    const teaActual = convertToNumber(localStorage.getItem("currentInterestTea"));

    // Determinar qué step mostrar según el dispositivo
    const stepToRender = currentStep;

    switch (stepToRender) {
      case 1:
        return (
          <>
            <div className="flex flex-col">
              {renderStepTitle("¡Tu crédito", "ha sido aprobado!")}
              <p style={stepSubtitleStyle}>Tienes un cupo disponible de</p>
            </div>

            <div className="flex flex-col gap-3 mt-3">
              <div style={{ ...stepCardStyle, padding: "20px 16px", marginBottom: !isDesktop && "20px" }}>
                <div className="flex items-center justify-center gap-4">
                  <Coins
                    className="w-10 h-10"
                    style={{ color: "#A68AFF" }}
                    strokeWidth={2}
                  />
                  <span
                    className="font-bold2"
                    style={{
                      color: "#FAFAFA",
                      fontSize: "clamp(32px, 5.5vh, 44px)",
                      lineHeight: 1,
                    }}
                  >
                    <Numeral format={"$0,0"} value={cupoDisponible} />
                  </span>
                </div>
                <div
                  className="flex items-center justify-center gap-6 mt-3"
                  style={{ color: "#BEBCC2", fontSize: "15px" }}
                >
                  {["100% digital", "Sin papeleos"].map((item) => (
                    <div key={item} className="flex items-center gap-2">
                      <span
                        style={{
                          ...iconCircleStyle,
                          width: "24px",
                          height: "24px",
                          minWidth: "24px",
                          backgroundColor: "#A68AFF",
                          color: "#1B1433",
                        }}
                      >
                        <Check className="w-4 h-4" strokeWidth={3} />
                      </span>
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              <div
                style={{
                  ...stepCardStyle,
                  display: "flex",
                  flexDirection: "column",
                  gap: "clamp(8px, 1.8vh, 16px)",
                }}
              >
                {[
                  {
                    icon: <Zap className="w-5 h-5" />,
                    title: "Tú eliges cuánto usar",
                    text: "Podrás seleccionar el monto que necesitas.",
                  },
                  // {
                  //   icon: <Clock className="w-5 h-5" />,
                  //   title: "Recibe tu dinero como prefieras",
                  //   text: "En minutos o en el horario habitual.",
                  // },
                  {
                    icon: <ShieldCheck className="w-5 h-5" />,
                    title: "Es seguro y confiable",
                    text: "Tu información está protegida.",
                  },
                ].map((item) => (
                  <div key={item.title} className="flex items-center gap-4">
                    <span style={iconCircleStyle}>{item.icon}</span>
                    <div className="flex flex-col">
                      <span
                        className="font-semibold2"
                        style={{ color: "#FAFAFA", fontSize: "16px" }}
                      >
                        {item.title}
                      </span>
                      <span style={{ color: "#BEBCC2", fontSize: "14px" }}>
                        {item.text}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div className="flex flex-col gap-2">
              {renderStepTitle("Estas son las", "condiciones de tu crédito")}
              <p style={stepSubtitleStyle}>Revisa el detalle antes de continuar.</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
              <div style={stepCardStyle}>
                {renderSectionHeader("", () => handleToggleDialogCupo(), "Editar cupo")}
                <div className="flex flex-col" style={{ gap: "clamp(6px, 1.3vh, 12px)" }}>
                  {renderDetailRow(
                    <CircleDollarSign className="w-5 h-5" />,
                    "Monto del crédito",
                    <Numeral format={"$0,0"} value={formDataOferta.selectedQuota} />,
                  )}
                  <div
                    className="pt-3"
                    style={{ borderTop: "1px solid rgba(201, 184, 255, 0.2)" }}
                  >
                    {renderDetailRow(
                      <CreditCard className="w-5 h-5" />,
                      "Recibirás en tu cuenta",
                      <Numeral format={"$0,0"} value={montoRecibido} />,
                      { highlight: true, bold: true },
                    )}
                  </div>
                </div>
              </div>

              <div style={stepCardStyle}>
                {renderSectionHeader("Detalle de pago", () => handleToggleDialog())}
                <div className="flex flex-col" style={{ gap: "clamp(6px, 1.3vh, 12px)" }}>
                  {renderDetailRow(
                    <Calendar className="w-5 h-5" />,
                    "Fecha límite de pago",
                    formatFechaLarga(formDataOferta.paydayLimit),
                  )}

                  {renderDetailRow(
                    <Calendar1 className="w-5 h-5" />,
                    "El plazo serán",
                    vencimientoEnDias + " días",
                  )}

                  {renderDetailRow(
                    <FileText className="w-5 h-5" />,
                    "Número de cuotas",
                    "1 cuota",
                  )}
                  {renderDetailRow(
                    <HandCoins className="w-5 h-5" />,
                    "Valor de la cuota",
                    <Numeral format={"$0,0"} value={total} />,
                  )}
                </div>
              </div>

              <div style={stepCardStyle}>
                {renderSectionHeader("Costos de tu crédito", () => handleToggleDialogFirma())}
                <div className="flex flex-col" style={{ gap: "clamp(6px, 1.3vh, 12px)" }}>
                  {renderDetailRow(
                    <Percent className="w-5 h-5" />,
                    `Intereses corriente${isValidNumber(teaActual) && teaActual > 0 ? ` (${teaActual}% E.A)` : ""}`,
                    <Numeral format={"$0,0"} value={interest} />,
                  )}
                  {renderDetailRow(
                    <FileText className="w-5 h-5" />,

                    formDataOferta.tipoFirma === "electronica"
                      ? "Firma Electrónica"
                      : "Firma Manuscrita",

                    costoFirma > 0 ?
                      <Numeral format={"$0,0"} value={costoFirma} /> :
                      <span>$0</span>
                  )}
                  <div
                    className="pt-3"
                    style={{ borderTop: "1px solid rgba(201, 184, 255, 0.2)" }}
                  >
                    {renderDetailRow(
                      <CreditCardCheck className="w-5 h-5" />,
                      "Total a pagar",
                      <Numeral format={"$0,0"} value={total} />,
                      { bold: true },
                    )}
                  </div>
                </div>
              </div>
              {renderContractLink("Ver contrato y condiciones completas")}
              <div style={stepCardStyle}>
                <div className="flex flex-col" style={{ gap: "clamp(6px, 1.3vh, 12px)" }}>
                  {renderDetailRow(
                    <ShieldLock className="w-8 h-8" style={{ color: "#A68AFF", flexShrink: 0 }} />,
                    <div className="flex flex-col">
                      <span style={{ color: "#d6d5d5", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                        Tu información está protegida
                      </span>
                      <span style={{ color: "#A68AFF", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                        Usamos encriptación y procesos seguros.
                      </span>
                    </div>
                  )}

                </div>
              </div>
            </div>

            {renderContractSheet()}
          </>
        );
      case 3:
        return (
          <>
            <div
              style={{
                marginBottom: "clamp(5px, 1vw, 40px)",
              }}
            >
              <h1
                className="font-bold2"
                style={{
                  fontSize: "clamp(24px, 2.5vw, 48px)",
                  color: "#FAFAFA",
                  lineHeight: "1.3",
                  wordWrap: "break-word",
                  display: "flex",
                  gap: "0.5rem",
                }}
              >
                ¡Tu crédito <h1 style={{ color: "#C9B8FF" }}>ha sido aprobado!</h1>
              </h1>

              <p
                style={{
                  fontSize: "clamp(14px, 1.2vw, 18px)",
                  color: "#BEBCC2",
                  lineHeight: "1.5",
                  wordWrap: "break-word",
                }}
              >
                {creditUserStore?.firstname
                  ? `¡${creditUserStore.firstname}!`
                  : ""}{" "}
                Tienes un cupo disponible de.
              </p>
            </div>
            <div className="custom-scrollbar" style={{ display: "flex", alignItems: "center", justifyContent: "center", overflowY: "auto", width: "100%", height: "900px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "20px", width: "750px", height: "100%", padding: "20px" }}>
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "16px" }}>
                  <div style={{ ...stepCardStyle, padding: "24px 28px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div className="flex items-center justify-start gap-6">
                      <Coins
                        className="w-14 h-14"
                        style={{ color: "#A68AFF", flexShrink: 0 }}
                        strokeWidth={2}
                      />
                      <div className="flex flex-col gap-1">
                        <span style={{ color: "#BEBCC2", fontSize: "14px" }}>Tienes un cupo disponible de</span>
                        <span
                          className="font-bold2"
                          style={{
                            color: "#FAFAFA",
                            fontSize: "clamp(36px, 4vw, 48px)",
                            lineHeight: 1,
                          }}
                        >
                          <Numeral format={"$0,0"} value={cupoDisponible} />
                        </span>
                      </div>
                    </div>
                    <div
                      className="flex items-center justify-start gap-8 mt-6"
                      style={{ color: "#BEBCC2", fontSize: "15px" }}
                    >
                      {["100% digital", "Sin papeleos"].map((item) => (
                        <div key={item} className="flex items-center gap-3">
                          <span
                            style={{
                              ...iconCircleStyle,
                              width: "28px",
                              height: "28px",
                              minWidth: "28px",
                              backgroundColor: "#A68AFF",
                              color: "#1B1433",
                            }}
                          >
                            <Check className="w-4 h-4" strokeWidth={3} />
                          </span>
                          <span style={{ fontSize: "15px" }}>{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "16px" }}>
                  <div
                    style={{
                      ...stepCardStyle,
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                      padding: "24px 28px",
                    }}
                  >
                    {[
                      {
                        icon: <Zap className="w-6 h-6" />,
                        title: "Tú eliges cuánto usar",
                        text: "Podrás seleccionar el monto que necesitas.",
                      },
                      // {
                      //   icon: <Clock className="w-6 h-6" />,
                      //   title: "Recibe tu dinero como prefieras",
                      //   text: "En minutos o en el horario habitual.",
                      // },
                      {
                        icon: <ShieldCheck className="w-6 h-6" />,
                        title: "Es seguro y confiable",
                        text: "Tu información está protegida.",
                      },
                    ].map((item) => (
                      <div key={item.title} className="flex items-start gap-4">
                        <span style={{ ...iconCircleStyle, flexShrink: 0 }}>{item.icon}</span>
                        <div className="flex flex-col gap-1">
                          <span
                            className="font-semibold2"
                            style={{ color: "#FAFAFA", fontSize: "15px" }}
                          >
                            {item.title}
                          </span>
                          <span style={{ color: "#BEBCC2", fontSize: "13px" }}>
                            {item.text}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      case 4:

        if (isDesktop) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                width: "-webkit-fill-available",
                height: isDesktopReize ? "-webkit-fill-available" : "100%",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  margin: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "visible",
                  gap: "5px",
                  marginBottom: "30px",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    marginBottom: "clamp(5px, 1vw, 40px)",
                  }}
                >
                  <h1
                    className="font-bold2"
                    style={{
                      fontSize: "clamp(24px, 2.5vw, 48px)",
                      color: "#FAFAFA",
                      lineHeight: "1.3",
                      wordWrap: "break-word",
                      display: "flex",
                      gap: "0.5rem",
                    }}
                  >
                    {creditUserStore?.firstname
                      ? `¡${creditUserStore.firstname}!`
                      : ""}{" "}
                    Estas son las <h1 style={{ color: "#C9B8FF" }}>condiciones de tu crédito</h1>
                  </h1>

                  <p
                    style={{
                      fontSize: "clamp(14px, 1.2vw, 18px)",
                      color: "#BEBCC2",
                      lineHeight: "1.5",
                      wordWrap: "break-word",
                    }}
                  >
                    {creditUserStore?.firstname
                      ? `¡${creditUserStore.firstname}!`
                      : ""}{" "}
                    Revisa el detalle antes de continuar.
                  </p>
                </div>

                <div className="custom-scrollbar" style={{ display: "flex", flexDirection: "column", gap: "30px", height: "100%", paddingRight: "10px", overflowY: "auto" }}>
                  <div style={{ display: "flex", gap: "30px", width: "100%", alignItems: "flex-start" }}>
                    <span
                      className="font-bold2"
                      style={{ color: "#C9B8FF", fontSize: "clamp(14px, 1.2vw, 16px)", width: "150px", flexShrink: 0, position: "sticky", top: 0, paddingTop: "10px" }}
                    >

                    </span>
                    <div style={{ display: "flex", flexDirection: "column", gap: "15px", flex: 1 }}>
                      <div style={{
                        display: "flex", flexDirection: "column", gap: "15px", border: "1px solid #29214F", borderRadius: "1rem", padding: "15px 30px 10px 30px",
                        background: "linear-gradient(145deg, rgba(28,18,43,0.95) 0%, rgba(13,9,20,0.98) 100%)",
                      }}>
                        <div style={{ display: "flex", flexDirection: "row", gap: "clamp(20px, 3vh, 30px)" }}>
                          <CircleDollarSign className="w-14 h-14" style={{ color: "#A68AFF", flexShrink: 0 }} />
                          <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <div className="flex flex-col">
                              <span style={{ color: "#d6d5d5", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                                Monto del crédito
                                {/* <Info className="w-5 h-5" style={{ color: "#A68AFF", flexShrink: 0 }} /> */}
                              </span>
                              <h2
                                className="font-bold2"
                                style={{
                                  fontSize: "clamp(15px, 1.5vw, 30px)",
                                  color: "#fff",
                                  fontWeight: "700",
                                  lineHeight: "1",
                                }}
                              >
                                <Numeral
                                  format={"$0,0"}
                                  value={formDataOferta.selectedQuota}
                                />
                              </h2>
                            </div>
                            <button
                              type="button"
                              onClick={handleToggleDialogCupo}
                              className="text-purple text-sm"
                              style={{
                                fontSize: "15px",
                                color: "#A68AFF",
                                fontWeight: "700",
                                lineHeight: "1",
                                cursor: "pointer"
                              }}
                            >
                              Editar cupo
                            </button>
                          </div>
                        </div>
                        <hr style={{ border: "1px solid #29214F" }} />

                        <div style={{ display: "flex", flexDirection: "row", gap: "clamp(20px, 3vh, 30px)", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "clamp(20px, 3vh, 30px)" }}>
                            <div style={{ borderRadius: "50%", background: "linear-gradient(145deg, rgba(28, 18, 43, 0.95) 0%, rgba(13, 9, 20, 0.98) 100%)", padding: "10px" }}>
                              <CreditCard className="w-8 h-8" style={{ color: "#A68AFF", flexShrink: 0 }} />
                            </div>
                            <div className="flex flex-col">
                              <span style={{ color: "#d6d5d5", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                                Recibirás en tu cuenta
                                {/* <Info className="w-5 h-5" style={{ color: "#A68AFF", flexShrink: 0 }} /> */}
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <h2
                              className="font-bold2"
                              style={{
                                fontSize: "clamp(15px, 1.5vw, 30px)",
                                color: "#A68AFF",
                                fontWeight: "700",
                                lineHeight: "1",
                              }}
                            >
                              <Numeral
                                format={"$0,0"}
                                value={formDataOferta.selectedQuota}
                              />
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: "30px", width: "100%", alignItems: "flex-start" }}>
                    <span
                      className="font-bold2"
                      style={{ color: "#C9B8FF", fontSize: "clamp(14px, 1.2vw, 16px)", width: "150px", flexShrink: 0, position: "sticky", top: 0, paddingTop: "10px", display: "flex", justifyContent: "flex-end" }}
                    >
                      Detalle de pago
                    </span>
                    <div style={{ display: "flex", flexDirection: "column", gap: "15px", flex: 1 }}>
                      <div style={{
                        display: "flex", flexDirection: "column", gap: "15px", border: "1px solid #29214F", borderRadius: "1rem", padding: "15px 30px 10px 30px",
                        background: "linear-gradient(145deg, rgba(28,18,43,0.95) 0%, rgba(13,9,20,0.98) 100%)",
                      }}>
                        {/* <span
                        className="font-bold2"
                        style={{ color: "#FAFAFA", fontSize: isDesktop ? "clamp(16px, 1.4vw, 18px)" : "clamp(15px, 2.2vh, 17px)" }}
                      >
                        Detalle de pago
                      </span> */}
                        <div style={{ display: "flex", flexDirection: "row", gap: "clamp(20px, 3vh, 30px)", alignItems: "center", justifyContent: "space-between", paddingLeft: "12px" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "clamp(20px, 3vh, 30px)" }}>
                            <CalendarDays className="w-8 h-8" style={{ color: "#A68AFF", flexShrink: 0 }} />
                            <div className="flex flex-col">
                              <span style={{ color: "#d6d5d5", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                                Fecha límite de pago
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <h2
                              className="font-bold2 flex flex-row"
                              style={{
                                fontSize: "15px",
                                color: "#d6d5d5",
                                fontWeight: "700",
                                lineHeight: "1",
                                gap: "15px",
                              }}
                            >
                              {formatFechaLarga(formDataOferta.paydayLimit)}
                              <a className="font-bold2"
                                onClick={handleToggleDialog}
                                style={{
                                  fontSize: "15px",
                                  color: "#A68AFF",
                                  fontWeight: "700",
                                  lineHeight: "1",
                                  cursor: "pointer"
                                }}>
                                Editar
                              </a>
                            </h2>
                          </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", gap: "clamp(20px, 3vh, 30px)", alignItems: "center", justifyContent: "space-between", paddingLeft: "12px" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "clamp(20px, 3vh, 30px)" }}>
                            <Calendar1 className="w-8 h-8" style={{ color: "#A68AFF", flexShrink: 0 }} />
                            <div className="flex flex-col">
                              <span style={{ color: "#d6d5d5", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                                El plazo serán
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <h2
                              className="font-bold2"
                              style={{
                                fontSize: "15px",
                                color: "#d6d5d5",
                                fontWeight: "700",
                                lineHeight: "1",
                              }}
                            >
                              {vencimientoEnDias} días
                            </h2>
                          </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "row", gap: "clamp(20px, 3vh, 30px)", alignItems: "center", justifyContent: "space-between", paddingLeft: "12px" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "clamp(20px, 3vh, 30px)" }}>
                            <FileText className="w-8 h-8" style={{ color: "#A68AFF", flexShrink: 0 }} />
                            <div className="flex flex-col">
                              <span style={{ color: "#d6d5d5", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                                Nuúmero de cuotas
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <h2
                              className="font-bold2"
                              style={{
                                fontSize: "18px",
                                color: "#d6d5d5",
                                fontWeight: "700",
                                lineHeight: "1",
                              }}
                            >
                              {"1 cuota"}
                            </h2>
                          </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "row", gap: "clamp(20px, 3vh, 30px)", alignItems: "center", justifyContent: "space-between", paddingLeft: "12px" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "clamp(20px, 3vh, 30px)" }}>
                            <HandCoins className="w-8 h-8" style={{ color: "#A68AFF", flexShrink: 0 }} />
                            <div className="flex flex-col">
                              <span style={{ color: "#d6d5d5", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                                Valor de la cuota
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <h2
                              className="font-bold2"
                              style={{
                                fontSize: "18px",
                                color: "#d6d5d5",
                                fontWeight: "700",
                                lineHeight: "1",
                              }}
                            >
                              <Numeral
                                format={"$0,0"}
                                value={total}
                              />
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: "30px", width: "100%", alignItems: "flex-start" }}>
                    <span
                      className="font-bold2"
                      style={{ color: "#C9B8FF", fontSize: "clamp(14px, 1.2vw, 16px)", width: "150px", flexShrink: 0, position: "sticky", top: 0, paddingTop: "10px", display: "flex", justifyContent: "flex-end" }}
                    >
                      Costos de tu crédito
                    </span>
                    <div style={{ display: "flex", flexDirection: "column", gap: "15px", flex: 1 }}>
                      <div style={{
                        display: "flex", flexDirection: "column", gap: "15px", border: "1px solid #29214F", borderRadius: "1rem", padding: "15px 30px 10px 30px",
                        background: "linear-gradient(145deg, rgba(28,18,43,0.95) 0%, rgba(13,9,20,0.98) 100%)",
                      }}>
                        <div style={{ display: "flex", flexDirection: "row", gap: "clamp(20px, 3vh, 30px)", alignItems: "center", justifyContent: "space-between", paddingLeft: "12px" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "clamp(20px, 3vh, 30px)" }}>
                            <Percent className="w-8 h-8" style={{ color: "#A68AFF", flexShrink: 0 }} />

                            <div className="flex flex-col">
                              <span style={{ color: "#d6d5d5", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                                Intereses corriente {isValidNumber(teaActual) && teaActual > 0 ? ` (${teaActual}% E.A)` : ""}
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <Numeral format={"$0,0"} value={interest} />
                          </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "row", gap: "clamp(20px, 3vh, 30px)", alignItems: "center", justifyContent: "space-between", paddingLeft: "12px" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "clamp(20px, 3vh, 30px)" }}>
                            <FileText className="w-8 h-8" style={{ color: "#A68AFF", flexShrink: 0 }} />
                            <div className="flex flex-col">
                              <span style={{ color: "#d6d5d5", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                                {formDataOferta.tipoFirma === "electronica"
                                  ? "Firma Electrónica"
                                  : "Firma Manuscrita"}
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <h2
                              className="font-bold2 flex flex-row"
                              style={{
                                fontSize: "15px",
                                color: "#d6d5d5",
                                fontWeight: "700",
                                lineHeight: "1",
                                gap: "15px"
                              }}
                            >
                              {costoFirma > 0 ?
                                <Numeral format={"$0,0"} value={costoFirma} /> :
                                <span>$0</span>
                              }
                              <a className="font-bold2"
                                onClick={handleToggleDialogFirma}
                                style={{
                                  fontSize: "15px",
                                  color: "#A68AFF",
                                  fontWeight: "700",
                                  lineHeight: "1",
                                  cursor: "pointer"
                                }}>
                                Editar
                              </a>
                            </h2>

                          </div>
                        </div>

                        <hr style={{ border: "1px solid #29214F" }} />
                        <div style={{ display: "flex", flexDirection: "row", gap: "clamp(20px, 3vh, 30px)", alignItems: "center", justifyContent: "space-between", paddingLeft: "12px" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "clamp(20px, 3vh, 30px)" }}>
                            <CreditCardCheck className="w-8 h-8" style={{ color: "#A68AFF", flexShrink: 0 }} />
                            <div className="flex flex-col">
                              <span style={{ color: "#d6d5d5", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                                Total a pagar
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <h2
                              className="font-bold2"
                              style={{
                                fontSize: "25px",
                                color: "#d6d5d5",
                                fontWeight: "700",
                                lineHeight: "1",
                              }}
                            >
                              <Numeral
                                format={"$0,0"}
                                value={total}
                              />
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: "30px", width: "100%", alignItems: "flex-start" }}>
                    <span
                      className="font-bold2"
                      style={{ color: "#C9B8FF", fontSize: "clamp(14px, 1.2vw, 16px)", width: "150px", flexShrink: 0, position: "sticky", top: 0, paddingTop: "10px" }}
                    >

                    </span>
                    <div style={{ display: "flex", flexDirection: "column", gap: "15px", flex: 1 }}>
                      <div style={{
                        display: "flex", flexDirection: "column", gap: "15px", border: "1px solid #29214F", borderRadius: "1rem", padding: "15px 30px 10px 30px", cursor: "pointer",
                        background: "linear-gradient(145deg, rgba(28,18,43,0.95) 0%, rgba(13,9,20,0.98) 100%)",
                      }}
                        onClick={() => handleToggleDialogContratos()}>
                        <div style={{ display: "flex", flexDirection: "row", gap: "clamp(20px, 3vh, 30px)", alignItems: "center", justifyContent: "space-between", paddingLeft: "12px" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "clamp(20px, 3vh, 30px)" }}>
                            <FileText className="w-8 h-8" style={{ color: "#A68AFF", flexShrink: 0 }} />
                            <div className="flex flex-col">
                              <span style={{ color: "#d6d5d5", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                                Ver contrato y condiciones completas
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <ChevronRight className="w-8 h-8" style={{ color: "#A68AFF", flexShrink: 0 }} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: "30px", width: "100%", alignItems: "flex-start" }}>
                    <span
                      className="font-bold2"
                      style={{ color: "#C9B8FF", fontSize: "clamp(14px, 1.2vw, 16px)", width: "150px", flexShrink: 0, position: "sticky", top: 0, paddingTop: "10px" }}
                    >

                    </span>
                    <div style={{ display: "flex", flexDirection: "column", gap: "15px", flex: 1 }}>
                      <div style={{
                        display: "flex", flexDirection: "column", gap: "15px", border: "1px solid #29214F", borderRadius: "1rem", padding: "15px 30px 10px 30px",
                        background: "linear-gradient(145deg, rgba(28,18,43,0.95) 0%, rgba(13,9,20,0.98) 100%)",
                      }}>
                        <div style={{ display: "flex", flexDirection: "row", gap: "clamp(20px, 3vh, 30px)", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "clamp(20px, 3vh, 30px)" }}>
                            <div style={{
                              borderRadius: "50%", background: "linear-gradient(145deg, rgba(28, 18, 43, 0.95) 0%, rgba(13, 9, 20, 0.98) 100%)", padding: "10px"
                            }}>
                              <ShieldLock className="w-8 h-8" style={{ color: "#A68AFF", flexShrink: 0 }} />
                            </div>
                            <div className="flex flex-col">
                              <span style={{ color: "#d6d5d5", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                                Tu información está protegida
                              </span>
                              <span style={{ color: "#A68AFF", fontSize: "clamp(12px, 0.9vw, 14px)", display: "flex", gap: "5px", alignItems: "center" }}>
                                Usamos encriptación y procesos seguros.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Grid de información - 3 columnas */}
                {/* <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: "0px 10px",
                    marginBottom: "clamp(30px, 4vh, 40px)",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <p
                      style={{
                        fontSize: "clamp(14px, 1.5vw, 20px)",
                        color: "#BEBCC2",
                      }}
                    >
                      Te podemos prestar:
                    </p>
                    <h2
                      className="font-bold2"
                      style={{
                        fontSize: "clamp(32px, 3vw, 70px)",
                        color: "#C9B8FF",
                        fontWeight: "700",
                        lineHeight: "1",
                      }}
                    >
                      <Numeral
                        format={"$0,0"}
                        value={formDataOferta.approvedQuota}
                      />
                    </h2>
                  </div>

                  <div style={{ textAlign: "center" }}>
                    <p
                      style={{
                        fontSize: "clamp(14px, 1.5vw, 20px)",
                        color: "#BEBCC2",
                      }}
                    >
                      El plazo serán:
                    </p>
                    <p
                      className="font-bold2"
                      style={{
                        fontSize: "clamp(16px, 2vw, 28px)",
                        color: "#FFFFFF",
                      }}
                    >
                      {vencimientoEnDias} días
                    </p>
                  </div>

                  <div style={{ textAlign: "center" }}>
                    <p
                      style={{
                        fontSize: "clamp(14px, 1.5vw, 20px)",
                        color: "#BEBCC2",
                      }}
                      className="font-semibold2"
                    >
                      Modalidad de Firma:
                    </p>
                    <p
                      className="font-bold2"
                      style={{
                        fontSize: "clamp(16px, 2vw, 28px)",
                        color: "#FFFFFF",
                      }}
                    >
                      {formDataOferta.tipoFirma === "electronica"
                        ? "Firma Electrónica"
                        : "Firma Manuscrita"}
                    </p>
                    <button
                      type="button"
                      onClick={handleToggleDialogFirma}
                      className="font-bold2"
                      style={{
                        color: "#C9B8FF",
                        fontSize: "clamp(12px, 1vw, 16px)",
                        cursor: "pointer",
                      }}
                    >
                      Elegir otra opción
                    </button>

                    <BottomSheet
                      open={openSheetFirma}
                      onOpenChange={setOpenSheetFirma}
                      headerContent={
                        <h2 className="font-semibold2">Modalidad de firma</h2>
                      }
                      isDesktop={isDesktop}
                      footerContent={
                        <div className="flex gap-5 h-16">
                          <PrevButton
                            onBack={() => {
                              setOpenSheetFirma(false);
                            }}
                            label={"Cancelar"}
                          />
                          <NextButton
                            onNext={(e) => {
                              setOpenSheetFirma(false);
                              handleInputChange(
                                (e = {
                                  target: {
                                    name: "tipoFirma",
                                    value: isSelectedTipoFirma,
                                  },
                                }),
                              );
                              saveOfertCredit({
                                ...offerCreditStore,
                                tipoFirma: isSelectedTipoFirma,
                              });
                            }}
                            label={"Seleccionar"}
                            disabled={
                              isSelectedTipoFirma === formDataOferta.tipoFirma
                            }
                          />
                        </div>
                      }
                    >
                      <p
                        className="text-center mb-4 font-semibold2"
                        style={{
                          width: "220px",
                          color: "#FAFAFA",
                          fontSize: "clamp(13px, 1.2vw, 16px)",
                        }}
                      >
                        ¿Cómo quieres firmar los documentos de tu crédito?
                      </p>

                      <div className="space-y-3 w-full flex flex-col gap-6 mb-3 mt-5">
                        <button
                          onClick={() => changeTipoFirma("electronica")}
                          name="tipoFirma"
                          className="w-full flex justify-between items-center px-4 py-3 border border-gray-300 text-gray-400"
                          style={{
                            height: "60px",
                            borderRadius: "2.5rem",
                            backgroundColor:
                              isSelectedTipoFirma === "electronica"
                                ? "#565584"
                                : "#2C2447",
                            color:
                              isSelectedTipoFirma === "electronica"
                                ? "#C9B8FF"
                                : "#BEBCC2",
                            border:
                              isSelectedTipoFirma === "electronica"
                                ? "1px solid #C9B8FF"
                                : "none",
                            cursor: "pointer",
                          }}
                        >
                          <div className="flex flex-row items-center gap-4">
                            <Signature
                              className="w-7 h-7"
                              style={{
                                color:
                                  isSelectedTipoFirma === "electronica"
                                    ? "#C9B8FF"
                                    : "#BEBCC2",
                              }}
                              strokeWidth={2.5}
                            />
                            <span
                              style={{
                                fontSize: "clamp(16px, 1.5vw, 20px)",
                                color:
                                  isSelectedTipoFirma === "electronica"
                                    ? "#C9B8FF"
                                    : "#BEBCC2",
                                fontWeight: "400",
                                fontFamily: "GT Walsheim Pro",
                              }}
                            >
                              Firma Electrónica
                            </span>
                          </div>
                          <Check
                            className="w-7 h-7"
                            style={{
                              color:
                                isSelectedTipoFirma === "electronica"
                                  ? "#C9B8FF"
                                  : "#BEBCC2",
                            }}
                            strokeWidth={2.5}
                          />
                        </button>
                        <button
                          onClick={() => changeTipoFirma("fisica")}
                          name="tipoFirma"
                          className="w-full flex justify-between items-center px-4 py-3 border border-gray-300 text-grayP"
                          style={{
                            backgroundColor:
                              isSelectedTipoFirma === "fisica"
                                ? "#565584"
                                : "#2C2447",
                            color:
                              isSelectedTipoFirma === "fisica"
                                ? "#C9B8FF"
                                : "#BEBCC2",
                            height: "60px",
                            borderRadius: "2.5rem",
                            border:
                              isSelectedTipoFirma === "fisica"
                                ? "1px solid #C9B8FF"
                                : "none",
                            cursor: "pointer",
                          }}
                        >
                          <div className="flex flex-row items-center gap-4">
                            <Edit3
                              className="w-7 h-7"
                              style={{
                                color:
                                  isSelectedTipoFirma === "fisica"
                                    ? "#C9B8FF"
                                    : "#BEBCC2",
                              }}
                              strokeWidth={2.5}
                            />
                            <span
                              style={{
                                fontSize: "clamp(16px, 1.5vw, 20px)",
                                color:
                                  isSelectedTipoFirma === "fisica"
                                    ? "#C9B8FF"
                                    : "#BEBCC2",
                                fontWeight: "400",
                                fontFamily: "GT Walsheim Pro",
                              }}
                            >
                              Firma Manuscrita
                            </span>
                          </div>
                          <Check
                            className="w-7 h-7"
                            style={{
                              color:
                                isSelectedTipoFirma === "fisica"
                                  ? "#C9B8FF"
                                  : "#BEBCC2",
                            }}
                            strokeWidth={2.5}
                          />
                        </button>
                      </div>
                    </BottomSheet>
                  </div>

                  <div style={{ textAlign: "center" }}>
                    <p
                      style={{
                        fontSize: "clamp(14px, 1.5vw, 20px)",
                        color: "#BEBCC2",
                      }}
                    >
                      Fecha de pago:
                    </p>
                    <p
                      className="font-bold2"
                      style={{
                        fontSize: "clamp(16px, 2vw, 28px)",
                        color: "#FFFFFF",
                      }}
                    >
                      {formDataOferta.paydayLimit}
                    </p>
                    <button
                      type="button"
                      onClick={handleToggleDialog}
                      className="font-bold2"
                      style={{
                        color: "#C9B8FF",
                        fontSize: "clamp(12px, 1vw, 16px)",
                        cursor: "pointer",
                      }}
                    >
                      Editar
                    </button>

                    <BottomSheet
                      open={openSheetFechas}
                      onOpenChange={setOpenSheetFechas}
                      headerContent={
                        <h2 className="font-semibold2">Fechas de Pago</h2>
                      }
                      isDesktop={isDesktop}
                      footerContent={
                        <div className="flex gap-5 h-16">
                          <PrevButton
                            onBack={() => {
                              setOpenSheetFechas(false);
                            }}
                            label={"Cancelar"}
                          />
                          <NextButton
                            onNext={(e) => {
                              setOpenSheetFechas(false);
                              handleInputChange({
                                target: {
                                  name: "paydayLimit",
                                  value: fechaSelected,
                                },
                              });
                            }}
                            label={"Seleccionar"}
                            disabled={
                              fechaSelected === formDataOferta.paydayLimit
                            }
                          />
                        </div>
                      }
                    >
                      <p
                        className="text-center mb-4 font-semibold2"
                        style={{
                          width: "195px",
                          color: "#FAFAFA",
                          fontSize: "clamp(13px, 1.2vw, 16px)",
                        }}
                      >
                        Escoge una de las fechas de pago disponibles:
                      </p>

                      <div className="space-y-3 w-full mb-3">
                        <div className="mt-2">
                          <FechasRadioGroup
                            Amount={formDataOferta.approvedQuota}
                            creditUser={formDataOferta}
                            onSelectDate={(fechaSeleccionada) => {
                              setFechaSelected(fechaSeleccionada);
                            }}
                          />
                        </div>
                      </div>
                    </BottomSheet>
                  </div>

                  <div style={{ textAlign: "center" }}>
                    <p
                      style={{
                        fontSize: "clamp(14px, 1.5vw, 20px)",
                        color: "#BEBCC2",
                      }}
                    >
                      Total a pagar:
                    </p>
                    <p
                      className="font-bold2"
                      style={{
                        fontSize: "clamp(16px, 2vw, 28px)",
                        color: "#FFFFFF",
                      }}
                    >
                      <Numeral format={"$0,0"} value={total} />
                    </p>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "clamp(15px, 4vh, 40px)",
                    }}
                  >
                    <button
                      onClick={() => handleToggleDialogContratos()}
                      type="button"
                      style={{
                        height: "clamp(48px, 5vh, 56px)",
                        borderRadius: "2rem",
                        backgroundColor: "#565584",
                        padding: "23px 14px",
                        border: "none",
                        cursor: "pointer",
                        transition: "all 0.2s",
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                      className="hover:opacity-90"
                    >
                      <FilesIcon
                        style={{
                          width: "clamp(18px, 1.8vw, 22px)",
                          height: "clamp(18px, 1.8vw, 22px)",
                          color: "#C9B8FF",
                        }}
                      />
                      <span
                        style={{
                          color: "#C9B8FF",
                          fontSize: "clamp(14px, 1.2vw, 18px)",
                          fontWeight: "500",
                        }}
                      >
                        Contrato y pagaré
                      </span>
                    </button>
                  </div>

                  <BottomSheet
                    open={dialogOpenContrato}
                    onOpenChange={setDialogOpenContrato}
                    isDesktop={isDesktop}
                    headerContent={
                      <div
                        className="flex rounded-2xl mx-auto"
                        style={{
                          backgroundColor: "#2C2447",
                          padding: "8px",
                          width: "200px",
                          margin: "0px",
                        }}
                      >
                        <button
                          onClick={() => handleTabClick("contrato")}
                          className={`flex-1 py-2 text-sm rounded-xl transition-all ${activeTab === "contrato"
                            ? "bg-purpleM text-white"
                            : "text-tgray"
                            }`}
                          style={{ cursor: "pointer" }}
                        >
                          Contrato
                        </button>
                        <button
                          onClick={() => handleTabClick("pagare")}
                          className={`flex-1 py-2 text-sm rounded-xl transition-all ${activeTab === "pagare"
                            ? "bg-purpleM text-white"
                            : "text-tgray"
                            }`}
                          style={{ cursor: "pointer" }}
                        >
                          Pagaré
                        </button>
                      </div>
                    }
                  >
                    <div className="space-y-3 w-full">
                      {activeTab === "contrato" ? (
                        <div
                          className="h-full rounded-t-3xl overflow-auto"
                          style={{
                            backgroundColor: "#2C2447",
                            color: "#FAFAFA",
                          }}
                        >
                          <ContractV3
                            basicInfo={creditUserStore}
                            userinfo={offerCreditStore}
                            creditUser={offerCreditStore}
                            firmaElectronica={
                              formDataOferta.tipoFirma === "electronica"
                                ? firmaElectronicaValue
                                : 0
                            }
                            dctoFirmaElectronica={
                              formDataOferta.tipoFirma === "electronica"
                                ? dctoFirmaElectronica
                                : 0
                            }
                            total={total}
                          />
                        </div>
                      ) : (
                        <div
                          className="h-full rounded-t-3xl overflow-auto"
                          style={{
                            backgroundColor: "#2C2447",
                            color: "#FAFAFA",
                          }}
                        >
                          <PromissoryV2
                            basicInfo={creditUserStore}
                            userinfo={offerCreditStore}
                          />
                        </div>
                      )}
                    </div>
                  </BottomSheet>

                  <BottomSheet
                    open={dialogOpenContratoFirma}
                    onOpenChange={setDialogOpenContratoFirma}
                    isDesktop={true}
                    headerContent={
                      <h2 className="font-semibold2">Firma manuscrita</h2>
                    }
                    footerContent={
                      <button
                        onClick={(e) => {
                          handleRequestPhysicalSignature();
                        }}
                        className="w-full bg-purple text-white py-3 gap-3 justify-center flex items-center"
                        style={{
                          borderRadius: "2.5rem",
                          height: "3.5rem",
                          fontSize: "20px",
                          backgroundColor:
                            isLoading || limitFirmaFisica > 2
                              ? "#2C2447"
                              : "#7E02FC",
                          cursor:
                            isLoading || limitFirmaFisica > 2
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        {isLoading ? (
                          <>
                            <div className="w-6 h-6 border-2 border-current border-t-transparent rounded-full animate-spin" />
                            Viajando...
                          </>
                        ) : (
                          <p style={{ fontSize: "1.1rem" }}>
                            {"Iniciar Proceso"}
                          </p>
                        )}
                      </button>
                    }
                  >
                    <div className="space-y-3 w-full">
                      <div
                        className="h-full rounded-t-3xl overflow-auto"
                        style={{
                          backgroundColor: "#2C2447",
                          color: "#FAFAFA",
                        }}
                      >
                        <ManualSignV3
                          isOpen={dialogOpenContratoFirma}
                          setOpen={setDialogOpenContratoFirma}
                        />
                      </div>
                    </div>
                  </BottomSheet>
                </div> */}
              </div>

            </div>
          );
        }
        break;

      default:
        return null;
    }
  };

  if (isApprovedCridit) {
    return (
      <Fragment>
        <div
          className="fixed inset-0 flex items-center justify-center min-h-screen w-full z-50"
          style={{
            color: "white",
            overflow: "hidden",
          }}
        >
          {/* Logo superior izquierda - solo desktop */}
          {isDesktop && (
            <div
              style={{
                background: "linear-gradient(145deg, rgba(28, 18, 43, 0.95) 0%, rgba(13, 9, 20, 0.98) 100%)",
                borderTopRightRadius: "50px",
                borderBottomRightRadius: "50px",
                width: "187px",
                height: "62px",
                position: "absolute",
                left: 0,
                top: 40,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                padding: "6px 20px 6px 0px",
              }}
            >
              <GalileIcon alt="Galilea" />
            </div>
          )}

          {/* Texto lateral izquierdo - solo desktop */}
          {isDesktop && (
            <div
              class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
              <div class="flex flex-row items-center justify-center gap-4 mr-2">
                <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
                  <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                    alt="colombia fintech" />
                </div>

                <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
                  <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                    alt="Superintendencia de Industria y Comercio" />
                </div>
              </div>
              <span
                class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
                Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
                Colombia con NIT: 901.582.748-5
              </span>

            </div>
          )}

          {/* Contenedor principal centrado */}
          {isDesktop ? (
            <div
              style={{
                width: "-webkit-fill-available",
                height: "-webkit-fill-available",
                background: "linear-gradient(145deg, rgba(28, 18, 43, 0.95) 0%, rgba(13, 9, 20, 0.98) 100%)",
                left: 390,
                top: "clamp(150px, 6vw, 200px)",
                position: "absolute",
                borderRadius: "30px",
                marginRight: "107px",
                marginBottom: "clamp(50px, 3vw, 80px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="flex flex-col items-center justify-center">
                {/* Componente de animación Rive */}
                <h1
                  className="font-bold2"
                  style={{
                    fontSize: "2rem",
                    width: "300px",
                    textAlign: "center",
                  }}
                >
                  ¡Luz Púrpura para Continuar!
                </h1>
                <AnimationComponent
                  animationUrl="/animations/checkanimation.riv"
                  width={"40vw"}
                  height={"40vh"}
                  isDesktop={isDesktop}
                  stateMachines={["chek-animation"]}
                />
                <p
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "200px",
                  }}
                >
                  <span>
                    ¡<span style={{ color: "#A68AFF" }}>Felicitaciones</span>!
                  </span>
                  <span
                    style={{
                      textAlign: "center",
                    }}
                  >
                    Tu solicitud fue aprobada y todos los sistemas están en
                    verde.
                  </span>
                </p>
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center">
              {/* Componente de animación Rive */}
              <h1
                className="font-bold2"
                style={{
                  fontSize: "2rem",
                  width: "300px",
                  textAlign: "center",
                }}
              >
                ¡Luz Púrpura para Continuar!
              </h1>
              <AnimationComponent
                animationUrl="/animations/checkanimation.riv"
                width={"20rem"}
                height={"40rem"}
                heightContainer={"25rem"}
                isDesktop={isDesktop}
                stateMachines={["chek-animation"]}
              />
              <p
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "200px",
                }}
              >
                <span>
                  ¡<span style={{ color: "#A68AFF" }}>Felicitaciones</span>!
                </span>
                <span
                  style={{
                    textAlign: "center",
                  }}
                >
                  Tu solicitud fue aprobada y todos los sistemas están en verde.
                </span>
              </p>
            </div>
          )}
        </div>
      </Fragment>
    );
  }

  if (isNotApprovedCridit) {
    return (
      <Fragment>
        <div
          className="fixed inset-0 flex items-center justify-center min-h-screen w-full z-50"
          style={{
            backgroundColor: "#000000",
            color: "white",
            overflow: "hidden",
          }}
        >

          {/* Logo superior izquierda - solo desktop */}
          {isDesktop && (
            <div
              style={{
                background: "linear-gradient(145deg, rgba(28, 18, 43, 0.95) 0%, rgba(13, 9, 20, 0.98) 100%)",
                borderTopRightRadius: "50px",
                borderBottomRightRadius: "50px",
                width: "187px",
                height: "62px",
                position: "absolute",
                left: 0,
                top: 40,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                padding: "6px 20px 6px 0px",
              }}
            >
              <GalileIcon
                alt="Galilea"
              /*  onClick={() => {
              navigate("/");
            }} */
              />
            </div>
          )}
          {/* Texto lateral izquierdo - solo desktop */}
          {isDesktop && (
            <div
              class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
              <div class="flex flex-row items-center justify-center gap-4 mr-2">
                <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
                  <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                    alt="colombia fintech" />
                </div>

                <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
                  <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                    alt="Superintendencia de Industria y Comercio" />
                </div>
              </div>
              <span
                class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
                Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
                Colombia con NIT: 901.582.748-5
              </span>
            </div>
          )}

          {/* Contenedor principal centrado */}
          {isDesktop ? (
            <div
              className="flex flex-col items-center justify-between"
              style={{
                height: "-webkit-fill-available",
                margin: "20px 0px 20px 0px",
              }}
            >
              <canvas
                ref={starsRef}
                className="fixed inset-0 w-full h-full pointer-events-none"
              ></canvas>
              {/* Componente de animación Rive */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-around",
                  height: "-webkit-fill-available",
                }}
              >
                <AnimationComponent
                  animationUrl="/animations/panel_nave.riv"
                  width={isDesktopReize ? "67rem" : "30rem"}
                  height={isDesktopReize ? "45rem" : "20rem"}
                  heightContainer={isDesktopReize ? "28rem" : "20rem"}
                  isDesktop={isDesktop}
                  stateMachines={["panel-rocket"]}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                    overflow: "auto",
                  }}
                >
                  <span
                    className="font-bold2"
                    style={{
                      color: "#A68AFF",
                      fontSize: " 25px",
                      width: "250px",
                      textAlign: "center",
                    }}
                  >
                    ¡Cambiamos la ruta de tu viaje!
                  </span>
                  <div
                    style={{
                      overflow: "auto",
                      display: "flex",
                      flexDirection: "column",
                      gap: "25px",
                    }}
                  >
                    <span style={{ textAlign: "center", width: "400px" }}>
                      Esta vía no fue aprobada; te sugerimos cuidar tu historial
                      crediticio y tu capacidad de endeudamiento.
                    </span>

                    <span
                      className="font-bold2"
                      style={{ textAlign: "center", width: "400px" }}
                    >
                      ¡Tranquilo!, Nuestro aliado te puede ofrecer hasta
                      $1.500.000 ¡solicítalo ahora!.
                    </span>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "-webkit-fill-available",
                  margin: "0px 46px",
                  gap: "20px",
                }}
              >
                <span
                  className="font-bold2"
                  style={{
                    textAlign: "center",
                    width: "200px",
                    fontSize: "35px",
                    color: "#1CC995",
                  }}
                >
                  CREZU
                </span>
                <button
                  type="button"
                  onClick={() => {
                    window.open(url, "_blank", "noopener,noreferrer");
                    cleanIndexDB();
                    navigate("/");
                  }}
                  style={{
                    height: "70px",
                    borderRadius: "2.5rem",
                    fontSize: "1.2rem",
                    fontWeight: "400",
                    cursor: "pointer",
                    backgroundColor: "#7E02FC",
                    width: "400px",
                    margin: "0px",
                  }}
                  className={`flex items-center justify-center gap-3 px-4 py-3 transition-all duration-200 flex-1 font-medium text-base text-white `}
                >
                  <p style={{ fontSize: "1.3rem" }}>Acceder al crédito</p>
                  <ArrowRight className="w-8 h-8" />
                </button>
              </div>
            </div>
          ) : (
            <div
              className="flex flex-col items-center justify-between"
              style={{
                height: "-webkit-fill-available",
                margin: "20px 0px",
              }}
            >
              <canvas
                ref={starsRef}
                className="fixed inset-0 w-full h-full pointer-events-none"
              ></canvas>
              {/* Componente de animación Rive */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-around",
                  height: "-webkit-fill-available",
                  overflow: "auto",
                }}
              >
                <AnimationComponent
                  animationUrl="/animations/panel_nave.riv"
                  width={"28rem"}
                  height={"40rem"}
                  heightContainer={"19rem"}
                  isDesktop={isDesktop}
                  stateMachines={["panel-rocket"]}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "-webkit-fill-available",
                    margin: "0px 56px",
                    gap: "20px",
                  }}
                >
                  <span
                    className="font-bold2"
                    style={{
                      textAlign: "center",
                      width: "200px",
                      fontSize: "35px",
                      color: "#1CC995",
                    }}
                  >
                    CREZU
                  </span>
                  <button
                    type="button"
                    onClick={() => {
                      window.open(url, "_blank", "noopener,noreferrer");
                      cleanIndexDB();
                      navigate("/");
                    }}
                    style={{
                      height: "70px",
                      borderRadius: "2.5rem",
                      fontSize: "1.2rem",
                      fontWeight: "400",
                      cursor: "pointer",
                      backgroundColor: "#7E02FC",
                      width: "-webkit-fill-available",
                      margin: "0px",
                    }}
                    className={`flex items-center justify-center gap-3 px-4 py-3 transition-all duration-200 flex-1 font-medium text-base text-white `}
                  >
                    <p style={{ fontSize: "1.3rem" }}>Acceder al crédito</p>
                    <ArrowRight className="w-8 h-8" />
                  </button>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "25px",
                    overflow: "auto",
                  }}
                >
                  <span
                    className="font-bold2"
                    style={{
                      color: "#A68AFF",
                      fontSize: " 25px",
                      width: "250px",
                      textAlign: "center",
                    }}
                  >
                    ¡Cambiamos la ruta de tu viaje!
                  </span>
                  <div
                    style={{
                      overflow: "visible",
                      display: "flex",
                      flexDirection: "column",
                      gap: "25px",
                    }}
                  >
                    <span style={{ textAlign: "center", width: "300px" }}>
                      Esta vía no fue aprobada; te sugerimos cuidar tu historial
                      crediticio y tu capacidad de endeudamiento.
                    </span>
                    <span
                      className="font-bold2"
                      style={{ textAlign: "center", width: "300px" }}
                    >
                      ¡Tranquilo!, Nuestro aliado te puede ofrecer hasta
                      $1.500.000 ¡solicítalo ahora!.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>

      {alertSession && (
        <>
          <InfoAlert
            isOpen={isOpenInfo}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></InfoAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
        </>
      )}

      <div className="w-full h-full">
        <StepContainer
          onNext={handleNext}
          onPrev={handlePrev}
          canGoNext={true}
          canGoPrev={isDesktop && currentStep > 3 ? true : false}
          finishText={"Aceptar condiciones"}
          isDesktop={isDesktop}
          errors={false}
          disabled={false}
          isLastStep={totalSteps}
          isLoading={isLoadingButton}
          nextText={currentStep === totalSteps ? "Aceptar" : "Continuar"}
          // title={stepTitles[currentStep - 1]}
          heightContainer={isDesktop ? "92%" : "100%"}
        // subtitle={currentStep === 1 ? "Tienes un cupo disponible de" : "Revisa los detalles de tu crédito"}
        >
          <div
            className="transition-all duration-300 ease-in-out opacity-100 transform translate-x-0"
            style={{
              width: "-webkit-fill-available",
              overflowY: "auto",
              height: isDesktop ? "-webkit-fill-available" : getFormHeightMovil(),
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            {!isDesktop && (
              <div className="text-center flex flex-col items-center px-2 mb-5">
                <div style={{ color: "#BEBCC2", fontSize: "14px" }}>
                  Paso {currentStepGeneral} de {stepTitlesGeneral.length}
                </div>
                <div
                  className="text-lg text-gray-800 max-w-50 sm:max-w-none"
                  style={{
                    fontSize: 17,
                    marginBottom: "16px",
                    marginTop: "8px",
                  }}
                >
                  {stepTitlesGeneral && stepTitlesGeneral[currentStepGeneral - 1]}
                </div>
              </div>
            )}

            {renderStep()}
          </div>
        </StepContainer>
      </div>

      {openDialog && (
        <BottomSheet
          open={openDialog}
          onOpenChange={setOpenDialog}
          isDesktop={isDesktop}
          isFirmaManuscrita={true}
          headerContent={<h2 className="font-semibold2">{titleDialog}</h2>}
          footerContent={
            <button
              onClick={(e) => {
                handleAccept();
              }}
              className="w-full bg-purple text-white py-3 font-semibold2"
              style={{
                borderRadius: "2.5rem",
                height: "3.5rem",
                fontSize: "clamp(20px, 1.5vw, 25px)",
              }}
            >
              Entendido
            </button>
          }
        >
          <div className="w-full">
            <div
              className="h-full flex flex-col items-center text-center font-semibold2"
              style={{
                color: "#FAFAFA",
                gap: "10px",
                fontSize: "20px",
                lineHeight: "27px",
              }}
            >
              <EmailOutlined style={{ width: "5rem", height: "5rem" }} />
              {descriptionDialog}
            </div>
          </div>
        </BottomSheet>
      )}

      <BottomSheet
        open={openSheetFirma}
        onOpenChange={setOpenSheetFirma}
        headerContent={
          <h2 className="font-semibold2">Modalidad de firma</h2>
        }
        isDesktop={isDesktop}
        footerContent={
          <div className="flex gap-5 h-16">
            <PrevButton
              onBack={() => {
                setOpenSheetFirma(false);
              }}
              label={"Cancelar"}
            />
            <NextButton
              onNext={(e) => {
                setOpenSheetFirma(false);
                handleInputChange(
                  (e = {
                    target: {
                      name: "tipoFirma",
                      value: isSelectedTipoFirma,
                    },
                  }),
                );
                saveOfertCredit({
                  ...offerCreditStore,
                  tipoFirma: isSelectedTipoFirma,
                });
              }}
              label={"Seleccionar"}
              disabled={
                isSelectedTipoFirma === formDataOferta.tipoFirma
              }
            />
          </div>
        }
      >
        <p
          className="text-center mb-4 font-semibold2"
          style={{
            width: "220px",
            color: "#FAFAFA",
            fontSize: "clamp(13px, 1.2vw, 16px)",
          }}
        >
          ¿Cómo quieres firmar los documentos de tu crédito?
        </p>

        <div className="space-y-3 w-full flex flex-col gap-6 mb-3 mt-5">
          <button
            onClick={() => changeTipoFirma("electronica")}
            name="tipoFirma"
            className="w-full flex justify-between items-center px-4 py-3 border border-gray-300 text-gray-400"
            style={{
              height: "60px",
              borderRadius: "2.5rem",
              backgroundColor:
                isSelectedTipoFirma === "electronica"
                  ? "#565584"
                  : "#2C2447",
              color:
                isSelectedTipoFirma === "electronica"
                  ? "#C9B8FF"
                  : "#BEBCC2",
              border:
                isSelectedTipoFirma === "electronica"
                  ? "1px solid #C9B8FF"
                  : "none",
              cursor: "pointer",
            }}
          >
            <div className="flex flex-row items-center gap-4">
              <Signature
                className="w-7 h-7"
                style={{
                  color:
                    isSelectedTipoFirma === "electronica"
                      ? "#C9B8FF"
                      : "#BEBCC2",
                }}
                strokeWidth={2.5}
              />
              <span
                style={{
                  fontSize: "clamp(16px, 1.5vw, 20px)",
                  color:
                    isSelectedTipoFirma === "electronica"
                      ? "#C9B8FF"
                      : "#BEBCC2",
                  fontWeight: "400",
                  fontFamily: "GT Walsheim Pro",
                }}
              >
                Firma Electrónica
              </span>
            </div>
            <Check
              className="w-7 h-7"
              style={{
                color:
                  isSelectedTipoFirma === "electronica"
                    ? "#C9B8FF"
                    : "#BEBCC2",
              }}
              strokeWidth={2.5}
            />
          </button>
          <button
            onClick={() => changeTipoFirma("fisica")}
            name="tipoFirma"
            className="w-full flex justify-between items-center px-4 py-3 border border-gray-300 text-grayP"
            style={{
              backgroundColor:
                isSelectedTipoFirma === "fisica"
                  ? "#565584"
                  : "#2C2447",
              color:
                isSelectedTipoFirma === "fisica"
                  ? "#C9B8FF"
                  : "#BEBCC2",
              height: "60px",
              borderRadius: "2.5rem",
              border:
                isSelectedTipoFirma === "fisica"
                  ? "1px solid #C9B8FF"
                  : "none",
              cursor: "pointer",
            }}
          >
            <div className="flex flex-row items-center gap-4">
              <Edit3
                className="w-7 h-7"
                style={{
                  color:
                    isSelectedTipoFirma === "fisica"
                      ? "#C9B8FF"
                      : "#BEBCC2",
                }}
                strokeWidth={2.5}
              />
              <span
                style={{
                  fontSize: "clamp(16px, 1.5vw, 20px)",
                  color:
                    isSelectedTipoFirma === "fisica"
                      ? "#C9B8FF"
                      : "#BEBCC2",
                  fontWeight: "400",
                  fontFamily: "GT Walsheim Pro",
                }}
              >
                Firma Manuscrita
              </span>
            </div>
            <Check
              className="w-7 h-7"
              style={{
                color:
                  isSelectedTipoFirma === "fisica"
                    ? "#C9B8FF"
                    : "#BEBCC2",
              }}
              strokeWidth={2.5}
            />
          </button>
        </div>
      </BottomSheet>
      <BottomSheet
        open={openSheetFechas}
        onOpenChange={setOpenSheetFechas}
        headerContent={
          <h2 className="font-semibold2">Fechas de Pago</h2>
        }
        isDesktop={isDesktop}
        footerContent={
          <div className="flex gap-5 h-16">
            <PrevButton
              onBack={() => {
                setOpenSheetFechas(false);
              }}
              label={"Cancelar"}
            />
            <NextButton
              onNext={(e) => {
                setOpenSheetFechas(false);
                handleInputChange({
                  target: {
                    name: "paydayLimit",
                    value: fechaSelected,
                  },
                });
              }}
              label={"Seleccionar"}
              disabled={
                fechaSelected === formDataOferta.paydayLimit
              }
            />
          </div>
        }
      >
        <p
          className="text-center mb-4 font-semibold2"
          style={{
            width: "195px",
            color: "#FAFAFA",
            fontSize: "clamp(13px, 1.2vw, 16px)",
          }}
        >
          Escoge una de las fechas de pago disponibles:
        </p>

        <div className="space-y-3 w-full mb-3">
          <div className="mt-2">
            <FechasRadioGroup
              Amount={formDataOferta.selectedQuota}
              creditUser={formDataOferta}
              onSelectDate={(fechaSeleccionada) => {
                setFechaSelected(fechaSeleccionada);
              }}
            />
          </div>
        </div>
      </BottomSheet>
      {renderContractSheet()}

      <BottomSheet
        open={dialogOpenContratoFirma}
        onOpenChange={setDialogOpenContratoFirma}
        isDesktop={isDesktop}
        headerContent={
          <h2 className="font-semibold2">Firma manuscrita</h2>
        }
        footerContent={
          <button
            onClick={(e) => {
              handleRequestPhysicalSignature();
            }}
            className="w-full bg-purple text-white py-3 gap-3 justify-center flex items-center"
            style={{
              borderRadius: "2.5rem",
              height: "3.5rem",
              fontSize: "20px",
              backgroundColor:
                isLoading || limitFirmaFisica > 2
                  ? "#2C2447"
                  : "#7E02FC",
              cursor:
                isLoading || limitFirmaFisica > 2
                  ? "not-allowed"
                  : "pointer",
            }}
          >
            {isLoading ? (
              <>
                <div className="w-6 h-6 border-2 border-current border-t-transparent rounded-full animate-spin" />
                Viajando...
              </>
            ) : (
              <p style={{ fontSize: "1.1rem" }}>
                {"Iniciar Proceso"}
              </p>
            )}
          </button>
        }
      >
        <div className="space-y-3 w-full">
          <div
            className="h-full rounded-t-3xl overflow-auto"
            style={{
              backgroundColor: "#2C2447",
              color: "#FAFAFA",
            }}
          >
            <ManualSignV3
              isOpen={dialogOpenContratoFirma}
              setOpen={setDialogOpenContratoFirma}
            />
          </div>
        </div>
      </BottomSheet>

      <BottomSheet
        open={openSheetRangoQupo}
        onOpenChange={setOpenSheetRangoQupo}
        isDesktop={isDesktop}
        headerContent={
          <h2 className="font-semibold2">Cupo aprobado</h2>
        }
        footerContent={
          <div className="flex gap-5 h-16">
            <PrevButton
              onBack={() => {
                setOpenSheetRangoQupo(false);
              }}
              label={"Cancelar"}
            />
            <NextButton
              onNext={(e) => {
                setOpenSheetRangoQupo(false);
                handleInputChange(
                  (e = {
                    target: {
                      name: "selectedQuota",
                      value: selectedQuota,
                    },
                  }),
                );
                saveOfertCredit({
                  ...offerCreditStore,
                  selectedQuota: selectedQuota,
                });
              }}
              label={"Seleccionar"}
            />
          </div>
        }
      >
        <p
          className="text-center mb-4 font-semibold2"
          style={{
            width: "195px",
            color: "#FAFAFA",
            fontSize: "15px",
          }}
        >
          Modifica tu cupo:
        </p>

        <div className="space-y-3 w-full mb-3">
          <div style={{ margin: "50px auto" }}>
            <AmountSlider
              min={200000}
              max={Number(cupoDisponible)}
              value={selectedQuota}
              step={10000}
              onChange={(value) => {
                setSelectedQuota(value);
              }}
            />
          </div>
        </div>
      </BottomSheet>

    </Fragment>

  );
};

export default RenovarDatosOfertaForm;
